var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              default: "",
              name: "help",
              label: _vm.$t("help"),
              icon: "fal fa-question-square"
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-md q-pb-xl q-mt-md", attrs: { name: "help" } },
            [
              _vm.$route.name === "login-help"
                ? _c("div", { staticClass: "text-center logo-institutional" }, [
                    _c("img", {
                      staticClass: "cursor-pointer",
                      attrs: { src: _vm.login_logo },
                      on: {
                        click: function($event) {
                          return _vm.$router.push({ name: "login" })
                        }
                      }
                    })
                  ])
                : _vm._e(),
              !_vm.access_token && _vm.clientName != "academiapoptrade"
                ? _c(
                    "q-alert",
                    {
                      staticClass: "q-mb-sm",
                      attrs: {
                        icon: "fal fa-key",
                        color: "tertiary",
                        actions: [
                          {
                            label: _vm.$t("recover_password"),
                            handler: function() {
                              this$1.$router.push({ name: "recover-password" })
                            }
                          }
                        ]
                      }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("recover_password_helper")) +
                          "\n            "
                      )
                    ]
                  )
                : _vm._e(),
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6" },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label": _vm.$t("name"),
                        error: _vm.$v.name.$error,
                        disable: _vm.block_fields
                      },
                      on: { input: _vm.$v.name.$touch },
                      model: {
                        value: _vm.name,
                        callback: function($$v) {
                          _vm.name = $$v
                        },
                        expression: "name"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-sm-6 " },
                  [
                    _c("q-input", {
                      attrs: {
                        "float-label":
                          (_vm.current_client === "academiacoral"
                            ? _vm.$t("cpf_help_info")
                            : _vm.$t("document")) +
                          " " +
                          (_vm.register_fields.document_mandatory ? "*" : ""),
                        error: _vm.$v.document.$error,
                        disable: _vm.block_fields
                      },
                      on: { input: _vm.$v.document.$touch },
                      model: {
                        value: _vm.document,
                        callback: function($$v) {
                          _vm.document = $$v
                        },
                        expression: "document"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("q-input", {
                      attrs: {
                        type: "email",
                        "float-label": _vm.$t("email"),
                        error: _vm.$v.email.$error,
                        disable: _vm.block_fields
                      },
                      on: { input: _vm.$v.email.$touch },
                      model: {
                        value: _vm.email,
                        callback: function($$v) {
                          _vm.email = $$v
                        },
                        expression: "email"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("q-input", {
                      attrs: {
                        type: "textarea",
                        rows: "5",
                        "float-label": _vm.$t("message"),
                        error: _vm.$v.message.$error
                      },
                      on: { input: _vm.$v.message.$touch },
                      model: {
                        value: _vm.message,
                        callback: function($$v) {
                          _vm.message = $$v
                        },
                        expression: "message"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "col-12 q-mt-md row justify-end q-mt-lg" },
                [
                  _c("vue-recaptcha", {
                    ref: "recaptcha",
                    staticClass: "q-mb-sm",
                    attrs: {
                      loadRecaptchaScript: false,
                      sitekey: _vm.getSiteKeyRecaptcha
                    },
                    on: {
                      verify: _vm.onVerifyRecaptcha,
                      expired: _vm.onExpiredRecaptcha
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "row gutter-sm justify-end" }, [
                _c(
                  "div",
                  {
                    staticClass: "col-xs-12 col-sm-3",
                    class: _vm.getOrder("cancel")
                  },
                  [
                    _c("q-btn", {
                      staticClass: "full-width",
                      attrs: {
                        color: "tertiary",
                        label: _vm.$t("back"),
                        icon: "far fa-chevron-left"
                      },
                      on: {
                        click: function($event) {
                          return _vm.backButton()
                        }
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "col-xs-12 col-sm-3",
                    class: _vm.getOrder("save")
                  },
                  [
                    _c("q-btn", {
                      staticClass: "full-width",
                      attrs: {
                        color: "secondary",
                        label: _vm.$t("send"),
                        icon: "far fa-envelope"
                      },
                      on: {
                        click: function($event) {
                          return _vm.sendEmail()
                        }
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }